import type { UserInfo } from '@/app/types';

export const isMembershipRevisionActive = (_userInfo?: Pick<UserInfo, 'id' | 'tags'> | null, _now = Date.now()) => true;
